exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-inventory-products-build-kit .modal-dialog{min-height:450px}", ""]);

// exports
